import React from "react";
import { Controller } from "react-hook-form";
import { FieldProp } from "../model/FieldProp";
import { UrlModel } from "../../../businessFoundation/Primitives/UrlManage/UrlModel";
import { TextField } from "@episerver/ui-framework";

const EmailField: React.FC<FieldProp<any>> = (props) => {
    const { index, property, control, errors } = props;
    const validationData = property.validationData as UrlModel;

    return (
        <Controller
            name={`extendedProperties[${index}].value`}
            control={control}
            rules={{
                required: {
                    value: !property.isNullable,
                    message: `${property.friendlyName} is required`,
                },
                pattern: {
                    value: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/i,
                    message: `${property.friendlyName} is invalid`,
                },
            }}
            render={({ field: { onChange, value } }) => (
                <TextField
                    id={`extendedProperties[${index}].value`}
                    type="text"
                    outlined
                    maxLength={parseInt(validationData.maxLength.toString())}
                    label={property.friendlyName}
                    helperText={errors.extendedProperties ? errors.extendedProperties[index]?.value?.message ?? property.description : property.description}
                    invalid={errors.extendedProperties && errors.extendedProperties[index]?.value ? true : false}
                    value={value ?? ""}
                    onChange={onChange}
                />
            )}
        />
    );
};

export default EmailField;
